import { useRef, useState, type ReactNode } from "react";
import { errorText } from "../base/state.js";

/** A saved setting responds immediately, prevents duplicate writes and rolls back a failed save. */
export function AsyncToggle({ checked, save, children, testId }: { checked: boolean; save(value: boolean): Promise<void>; children: ReactNode; testId: string }) {
  const [pending, setPending] = useState<boolean | null>(null), [error, setError] = useState("");
  const writing = useRef(false);
  const change = async (value: boolean) => {
    if (writing.current) return;
    writing.current = true; setPending(value); setError("");
    try { await save(value); }
    catch (failure) { setError(errorText(failure)); }
    finally { writing.current = false; setPending(null); }
  };
  return <div><label className="row" style={{ minHeight: 44, alignItems: "flex-start" }}>
    <input type="checkbox" checked={pending ?? checked} disabled={pending !== null} aria-busy={pending !== null} onChange={event => void change(event.target.checked)} data-testid={testId} />
    <span>{children}</span>
  </label>{error ? <p role="alert">{error}</p> : null}</div>;
}
